// extracted by mini-css-extract-plugin
export var animationContainer = "_lx-0";
export var footer = "_lx-1";
export var gray = "_lx-2";
export var lineItem = "_lx-3";
export var lineItemImage = "_lx-4";
export var lineItemInfo = "_lx-5";
export var lineItemText = "_lx-6";
export var lineItems = "_lx-7";
export var modalContent = "_lx-8";
export var options = "_lx-9";
export var orderName = "_lx-a";
export var refundAmount = "_lx-b";